document.addEventListener('DOMContentLoaded', () => {
  // 'Back'-link closes the lightbox
  // (currently on the "contact/directions/booking" page, directions popup pages)
  // (when page embedded as iframe and
  // 'Back'-link being inside the iframe page)
  if(window.parent?.lightboxHtml5) {
    const backLinkEl = document.querySelector('.back-link');
    if(backLinkEl) {
      backLinkEl.addEventListener('click', closeLightboxAndSkipLink);
      backLinkEl.addEventListener('touch', closeLightboxAndSkipLink);
    }
  }
});

// close the lightbox and skip the default link action (go to href)
function closeLightboxAndSkipLink(e) {
  if(window.self !== window.top &&     // only when actually in lightbox iframe
     window.parent?.lightboxHtml5  ) { // + lightbox in parent available
    window.parent.lightboxHtml5.close(false); // no new history when closing
    e.preventDefault();
  }
}




// clear the `(empty)` booking form fields when initially focused ("selected") (notably on mobile)
const clearInputDefaultOnInitialFocus = (event) => {
  const inputEl = event.target;

  // only when current value equals default value, and when reset flag was not set
  if(inputEl.value === inputEl.defaultValue) {
    inputEl.setAttribute('value', ''); // empty the input element
  }

  // stop listening to `focus` events (reset only once, at initial focus ("select"))
  inputEl.removeEventListener('focus', clearInputDefaultOnInitialFocus);
};

const nameContactFormFields = document.querySelectorAll('input[name^="names_"]:is([name$="[first_name]"],[name$="[last_name]"])');
nameContactFormFields.forEach(field => field.addEventListener('focus', clearInputDefaultOnInitialFocus));
